// Exam Type ID.js

import { createSlice } from '@reduxjs/toolkit';

const ExamTypeSlice = createSlice({
  name: 'examType',
  initialState: {
    defaultExamData: null,
  },
  reducers: {
    setDefaultExamData: (state, action) => {
      state.defaultExamData = action.payload;
    },
  },
});

export const { setDefaultExamData } = ExamTypeSlice.actions;
export default ExamTypeSlice.reducer;
